export default __webpack_public_path__ + "static/2-a164ea4642d86566925244b6980daec8.jpeg";